import React from 'react';

import { ReactComponent as Logo } from './baseIcon.svg';

import './infoDialogue.css';

export default class InfoDialogue extends React.Component {
  bgclick = e => {
    if (this.props.bgclick) {
      if (e.target.classList.contains('modal')) {
        this.props.bgclick();
      }
    }
  };

  render() {
    if (this.props.visible) {
      return (
        <>
          <div className="modal" onClick={this.bgclick}>
            <div className="infoDialogue">
              <div className="modal-title">{this.props.title}</div>
              <div className="content">
                <Logo />
                <p>
                  Jottle will be your home for all your liturgical typesetting
                  needs. You can try it out now. The full thing is coming soon!
                  If you want to be on the mailing list to find out more
                  updates, <a href="mailto:info@jottle.io">drop us an email</a>{' '}
                  or{' '}
                  <a
                    href="https://twitter.com/jottleio"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    follow us on Twitter
                  </a>
                  . You may also like to{' '}
                  <a href="https://incymbalis.net/introducing-jottle.html">
                    read an introduction to why Jottle is so needed!
                  </a>
                </p>
                <p>
                  Jottle incorporates several open-source projects. These are{' '}
                  <a
                    href="https://www.pagedmedia.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Paged.js
                  </a>
                  ,{' '}
                  <a
                    href="https://reactjs.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    React
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://github.com/iamstarkov/typographic-base"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Typographic Base
                  </a>
                  , all of which are available under the{' '}
                  <a
                    href="https://opensource.org/licenses/MIT"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    MIT licence
                  </a>
                  , and{' '}
                  <a
                    href="https://github.com/jcuenod/ReferenceParser"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ReferenceParser
                  </a>
                  , available under the{' '}
                  <a
                    href="https://www.isc.org/licenses/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ISC licence
                  </a>
                  .
                </p>
                <p>
                  Please note that Jottle does not, and will not, work in
                  Internet Explorer. The page rendering functionality is broken
                  in Microsoft Edge: we hope to have this fixed soon.
                </p>
                <p>
                  Jottle {process.env.REACT_APP_VERSION} (r
                  {process.env.REACT_APP_GIT_SHA}) <br />© Fr Sam Korn{' '}
                  {new Date().getFullYear()}
                </p>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  }
}
